/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */

/**
 * * `invited` - Invited
 * * `applied` - Applied
 * * `passed_screening` - Passed Screening
 * * `interviewing` - Interviewing
 * * `offered` - Offered
 */
export type FunnelStageEnum = typeof FunnelStageEnum[keyof typeof FunnelStageEnum];


export const FunnelStageEnum = {
  invited: 'invited',
  applied: 'applied',
  passed_screening: 'passed_screening',
  interviewing: 'interviewing',
  offered: 'offered',
} as const;
